import { useCallback, useContext, useEffect, useState } from "react";

import { CustomerTitledPage } from "../../TitledPage";

import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Checkbox from "@mui/material/Checkbox";
import Grid from "@mui/material/Grid";
import OutlinedInput from "@mui/material/OutlinedInput";
import Pagination from "@mui/material/Pagination";
import Paper from "@mui/material/Paper";
import Tab from "@mui/material/Tab";
import Tabs from "@mui/material/Tabs";
import Typography from "@mui/material/Typography";

import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";

import { green, grey, pink, yellow } from "@mui/material/colors";
import { useLocation, useNavigate } from "react-router-dom";
import { SYSTEM_PATH_COMPANY } from "../../../App";
import { MSG_ERR_UNEXPECTED } from "../../../common/message";
import AddProductDialog from "../../../components/dialog/addProductDialog/AddProductDialog";
import useShortcut from "../../../hooks/useShortcut";
import { searchShopInfoList } from "../../../http/api/CustomerAPI";
import { postMarketCalendarSearchNextOpenDateInfoAPI } from "../../../http/api/MarketCalendarAPI";
import {
  postMarketPriceSearchIdAPI,
  postMarketPriceSearchTableInfoListAPI,
  postMarketPriceUpdateInfoAPI,
} from "../../../http/api/MarketPriceAPI";
import { getListOrderDetail, insertOrder } from "../../../http/api/OrderAPI";
import {
  getDisplayOriginWithOther,
  getDisplaySize,
} from "../../../utils/Items";
import { decrypt } from "../../../utils/crypto";
import {
  decimalToPercentDecimal,
  getAmPmHour,
  getDateAfter,
  getHyphenedDate,
  getYearMonthDateDisplay,
} from "../../../utils/utils";
import AddProductDetailMasterDialog from "../../../components/dialog/addProductDetailMasterDialog/AddProductDetailMasterDialog";
import AddProductMasterDialog from "../../../components/dialog/addProductMasterDialog/AddProductMasterDialog";
import Decimal from "decimal.js";
import { getPrimePrice, getSellingPrice } from "../../../utils/orderForm";
import { ScreenStatusContext } from "../../../context/ScreenStatusContext";
import { confirmWhenChanged } from "../../../utils/validation";
import {stripTrailingZeros} from "../../../utils/decimal";
//import { getOrderIsLimited } from "./logic/order";

const infoTableCellSx = {
  fontSize: 18,
};

// 注文票の行の最大数
const maxOrderTableRows = 20;
// 1ページに掲載するデータ票の最大数
const maxTablesOnPage = 1;

// 注文票カラム名
const priceTableColumnNames = {
  productName: "商品",
  origin: "産地",
  productClass: "規格",
  marketPrice: "市況価格(税抜)",
  unitPriceParKilo: "キロ単価(税抜)",
  primePrice: "原価(税抜)",
  sellingPrice: "売価(税抜)",
  sellingPriceMarkUpRate: "値入率",
  orderQuantity: "注文数",
  remarks: "備考",
};

// テキストボックス　フォーカス時に全選択する
const onFocusInput = (event) => {
  event.target.select();
};

// 検索フォーム
function OrderDataSearchForm(props) {
  // const {searchCondition,setSearchCondition} = props;
  const [searchCondition, setSearchCondition] = useState(props.searchCondition);

  const handleChangeSearchConditionInput = (searchProp) => (event) => {
    if (event.target.type === "checkbox") {
      setSearchCondition({
        ...searchCondition,
        [searchProp]: event.target.checked,
      });
    } else {
      setSearchCondition({
        ...searchCondition,
        [searchProp]: event.target.value,
      });
    }
  };

  const handleChangeSearchConditionNumberInput = (searchProp) => (event) => {
    const inputValue = event.target.value;

    if (inputValue === "") {
      setSearchCondition({ ...searchCondition, [searchProp]: 0 });
    }
    if (inputValue.match("^[0-9,]+$")) {
      setSearchCondition({
        ...searchCondition,
        [searchProp]: parseInt(inputValue.replaceAll(",", "")),
      });
    }
  };

  const handleBlurSearchConditionInput = (searchProp) => (event) => {
    setSearchCondition({
      ...searchCondition,
      [searchProp]: parseInt(event.target.value.replaceAll(",", "")),
    });
  };

  function handleSearchClick() {
    props.setSearchCondition(searchCondition);
  }

  return (
    <Box border="1px solid blue" borderRadius={1} padding={2}>
      商品検索
      <Box marginLeft={2}>
        <Grid container alignItems="center" spacing={2}>
          <Grid item>
            商品名:&nbsp;
            <OutlinedInput
              onFocus={onFocusInput}
              onChange={handleChangeSearchConditionInput("productName")}
              value={searchCondition.productName}
              sx={{ width: 180 }}
            />
          </Grid>
          <Grid item>
            産地:&nbsp;
            <OutlinedInput
              onFocus={onFocusInput}
              onChange={handleChangeSearchConditionInput("origin")}
              value={searchCondition.origin}
              sx={{ width: 100 }}
            />
          </Grid>
          {/* <Grid item>
            規格:&nbsp;
            <OutlinedInput
              onFocus={onFocusInput}
              onChange={handleChangeSearchConditionInput("productClass")}
              value={searchCondition.productClass}
              sx={{ width: 100 }}
            />
          </Grid> */}
          <Grid item>
            <Box>
              価格:&nbsp;
              <OutlinedInput
                type="text"
                inputProps={{ min: 0, step: 1, sx: { textAlign: "right" } }}
                onFocus={onFocusInput}
                onChange={handleChangeSearchConditionNumberInput("priceFrom")}
                onBlur={handleBlurSearchConditionInput("priceFrom")}
                value={
                  searchCondition.priceFrom
                    ? searchCondition.priceFrom.toLocaleString()
                    : null
                }
                sx={{ width: 100 }}
              />{" "}
              &nbsp;円以上&nbsp;
              <OutlinedInput
                type="text"
                inputProps={{ min: 0, step: 1, sx: { textAlign: "right" } }}
                onFocus={onFocusInput}
                onChange={handleChangeSearchConditionNumberInput("priceTo")}
                onBlur={handleBlurSearchConditionInput("priceTo")}
                value={
                  searchCondition.priceTo
                    ? searchCondition.priceTo.toLocaleString()
                    : null
                }
                sx={{ width: 100 }}
              />{" "}
              &nbsp;円以下
            </Box>
          </Grid>
        </Grid>
        <Grid container spacing={2}>
          <Grid item xs="auto">
            <Checkbox
              onChange={handleChangeSearchConditionInput("includeShortage")}
              checked={searchCondition.includeShortage}
              sx={{ marginLeft: -2 }}
            />{" "}
            &nbsp;欠品の商品情報を含む
          </Grid>
          <Grid item xs>
            <Checkbox
              onChange={handleChangeSearchConditionInput("hasOrder")}
              checked={searchCondition.hasOrder}
            />{" "}
            &nbsp;注文数が1件以上の商品で絞る
          </Grid>
          <Grid item xs="auto">
            <Button variant="contained" onClick={handleSearchClick}>
              検索
            </Button>
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
}

// 注文票タブ内容
// props...value = タブ番号 tabPosition = 現在タブ番号のstate
function TableTabContent(props) {
  const value = props.value;
  const tabPosition = props.tabPosition;
  return <Box hidden={tabPosition !== value}>{props.children}</Box>;
}

// 注文票(編集用)
// props...
// data = 表のデータ, minIndex = 注文票全体配列におけるこの表の最小index,
// updateInputOrderUnits...注文票データ注文数(index, value) => void,
function OrderEditTable(props) {
  const orderTableData = props.data;
  const minIndex = props.minIndex;
  const updateInputOrderUnits = props.updateInputOrderUnits;
  const priceTableSetting = props.priceTableSetting;

  // 表のデータ行1行分
  function OrderTableRow(props) {
    const index = props.index;
    const isShowName = props.isShowName;
    const isShowOrigin = props.isShowOrigin;
    const oldOrderQuantity = props.data.orderQuantity;
    const shortcut = props.shortcut;
    const [data, setData] = useState(props.data);
      const onChangeOrderUnits = (event) => {
          let inputValue = event.target.value;
          let newOrderQuantity;

          if (inputValue === "") {
              newOrderQuantity = 0;
          } else if (/^\d*\.?\d*$/.test(inputValue)) {
              newOrderQuantity = parseFloat(inputValue);
              inputValue = newOrderQuantity.toString();
              event.target.value = inputValue;
          } else {
              return;
          }

          setData({
              ...data,
              orderQuantity: newOrderQuantity,
              isDataChanged: oldOrderQuantity !== newOrderQuantity,
          });
      };



      const onBlurOrderUnits = async (event) => {
      const orderQuantity = event.target.value;
      console.log(`Blur index : ${index} orderQ : ${data.orderQuantity}`);
      if (data.isDataChanged) {
        updateInputOrderUnits(index, orderQuantity, data.isDataChanged);
      }
    };

    function HandleFocus(event) {
      console.log(event.target.id);
      ChangeColorRow(event.target, yellow[100]);
    }

    function HandleBlur(event) {
      ChangeColorRow(event.target, "inherit");
    }

    function ChangeColorRow(target, color) {
      let parentElement = target.parentNode;
      while (parentElement && parentElement.tagName !== "TR") {
        parentElement = parentElement.parentNode;
      }
      parentElement.style.backgroundColor = color;
    }

    function GetFocusingItem() {
      let focusingItem = document.activeElement;
      let id = focusingItem.id;
      let element = id.split("-");
      let tab = element[0];
      let cell = element[1];

      let patt1 = /[a-zA-Z]/g;
      let patt2 = /[0-9]/g;
      let letters = cell.match(patt1).join("");
      let digits = parseInt(cell.match(patt2).join(""));
      return { tab, item: letters, index: digits };
    }

    function HandlePressKey(event) {
      if (event.key === "Enter") {
        event.preventDefault();
        FocusNavigation(event.shiftKey);
      }
    }

    async function FocusNavigation(isPrevious = false) {
      let focusing = GetFocusingItem();
      document.activeElement.blur();
      await setTimeout(async () => {
        let step = isPrevious ? -1 : 1;
        let nextItem;
        let nextItemId;
        do {
          let nextStep = (focusing.index += step);
          if (nextStep % maxOrderTableRows == 0 && !isPrevious) {
            let listPagingButton =
              document.getElementById("paging").children[0].children;
            listPagingButton[listPagingButton.length - 1].children[0].click();
            await setTimeout(() => {}, 100);
          }
          if ((nextStep + 1) % maxOrderTableRows == 0 && isPrevious) {
            let listPagingButton =
              document.getElementById("paging").children[0].children;
            listPagingButton[0].children[0].click();
            await setTimeout(() => {}, 100);
          }
          nextItemId = `${focusing.tab}-${focusing.item + nextStep}`;
          nextItem = document.getElementById(nextItemId);
        } while (nextItem.disabled);
        nextItem.focus();
        nextItem.select();
      }, 100);
    }

    return (
      <TableRow
        sx={{
          backgroundColor: data.isAdditionalOrder
            ? green[50]
            : data.isDataChanged
            ? pink[50]
            : "",
        }}
        onKeyPress={HandlePressKey}
        onFocus={HandleFocus}
        onBlur={HandleBlur}
      >
        {/* 商品名 */}
        <TableCell
          // components="th"
          // scope="row"
          sx={{
            fontSize: 20,
            fontWeight: "bold",
            height: 28,
            width: 210,
          }}
        >
          {isShowName && data.productName}
        </TableCell>
        {/* 産地 */}
        <TableCell sx={{ ...infoTableCellSx, width: 150 }}>
          {(isShowName || isShowOrigin) && data.origin}
        </TableCell>
        {/* 規格 */}
        <TableCell sx={{ ...infoTableCellSx, width: 120 }}>
          {getDisplaySize(
            data.rank,
            data.productClass,
            data.weight,
            data.weightUnit,
            data.packing,
            data.quantity
          )}
        </TableCell>
        {/* 価格 */}
        {data.isUsingSellingPrice ? (
          <>
            {/* 原価 */}
            <TableCell
              sx={{ ...infoTableCellSx, textAlign: "right", width: 100 }}
            >
              {data.isShortage ? "ー" : data.primePrice.toLocaleString()}
            </TableCell>
            {/* 売価値入率 */}
            <TableCell
              sx={{ ...infoTableCellSx, textAlign: "right", width: 100 }}
            >
              {data.isShortage ? "ー" : data.sellingPriceMarkUpRatePercentage}
            </TableCell>
            {/* 売価 */}
            <TableCell
              sx={{ ...infoTableCellSx, textAlign: "right", width: 100 }}
            >
              {data.isShortage ? "ー" : data.sellingPrice.toLocaleString()}
            </TableCell>
          </>
        ) : (
          <TableCell
            sx={{ ...infoTableCellSx, textAlign: "right", width: 100 }}
          >
            {data.isShortage ? "ー" : (data.marketPrice || 0).toLocaleString()}
          </TableCell>
        )}

        {/* 注文数 */}
        <TableCell sx={{ ...infoTableCellSx, width: 100, padding: 1 }}>
          <OutlinedInput
            type="number"
            onFocus={onFocusInput}
            onChange={onChangeOrderUnits}
            onBlur={onBlurOrderUnits}
            inputProps={{
              min: 0,
              step: "any",
              sx: { ...infoTableCellSx, textAlign: "right",
                  '&::-webkit-outer-spin-button': {
                  display: 'none',
                },
                '&::-webkit-inner-spin-button': {
                  display: 'none',
                },
                '&[type=number]': {
                  MozAppearance: 'textfield',
                },},

            }}
            value={stripTrailingZeros(data.orderQuantity) || 0}
            disabled={priceTableSetting.orderIsLimited}
            sx={{ width: 100 }}
            id={`${data.priceDetailTypeId}-orderInput${index}`}
          />
          {data.orderingUnit}
        </TableCell>

        {/* 備考 */}
        <TableCell sx={{ ...infoTableCellSx, width: 180, padding: 1 }}>
          {data.remarks}
        </TableCell>
      </TableRow>
    );
  }

  // 単価列名出力設定
  const getUnitColumnName = (priceTableSetting) => {
    return priceTableSetting.unitPriceCd === 2
      ? priceTableColumnNames.unitPriceParKilo
      : priceTableColumnNames.marketPrice;
  };

  if (orderTableData && orderTableData.length > 0) {
    return (
      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell
                sx={{ ...infoTableCellSx, backgroundColor: grey[100] }}
              >
                {priceTableColumnNames.productName}
              </TableCell>
              <TableCell
                sx={{ ...infoTableCellSx, backgroundColor: grey[100] }}
              >
                {priceTableColumnNames.origin}
              </TableCell>
              <TableCell
                sx={{ ...infoTableCellSx, backgroundColor: grey[100] }}
              >
                {priceTableColumnNames.productClass}
              </TableCell>
              {priceTableSetting.isUsingSellingPrice ? (
                <>
                  <TableCell
                    sx={{ ...infoTableCellSx, backgroundColor: grey[100] }}
                  >
                    {priceTableColumnNames.primePrice}
                  </TableCell>
                  <TableCell
                    sx={{ ...infoTableCellSx, backgroundColor: grey[100] }}
                  >
                    {priceTableColumnNames.sellingPriceMarkUpRate}
                  </TableCell>
                  <TableCell
                    sx={{ ...infoTableCellSx, backgroundColor: grey[100] }}
                  >
                    {priceTableColumnNames.sellingPrice}
                  </TableCell>
                </>
              ) : (
                <TableCell
                  sx={{ ...infoTableCellSx, backgroundColor: grey[100] }}
                >
                  {getUnitColumnName(priceTableSetting)}
                </TableCell>
              )}

              <TableCell
                sx={{ ...infoTableCellSx, backgroundColor: grey[100] }}
              >
                {priceTableColumnNames.orderQuantity}
              </TableCell>
              <TableCell
                sx={{ ...infoTableCellSx, backgroundColor: grey[100] }}
              >
                {priceTableColumnNames.remarks}
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {orderTableData.map((data, i) => {
              return (
                <OrderTableRow
                  data={data}
                  index={i + minIndex}
                  key={"data_" + (i + minIndex).toString()}
                  isShowName={
                    i > 0 && data.productId == orderTableData[i - 1].productId
                      ? false
                      : true
                  }
                  isShowOrigin={
                    i > 0 && data.origin == orderTableData[i - 1].origin
                      ? false
                      : true
                  }
                  shortcut={props.shortcut}
                />
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
    );
  }

  return null;
}

// 注文票タブの内容
function OrderTableTabContent(props) {
  const { orderData, updateOrder, priceDetailTypeId, priceTableSetting } =
    props;
  const [page, setPage] = useState(1);
  const updateInputOrderUnits = (index, unitsValue, isDataChanged) => {
    orderData[index].orderQuantity = unitsValue;
    updateOrder(orderData[index], orderData[index]);
  };

  const handleChangeTablePage = (event, page_num) => {
    setPage(page_num);
  };

  const getMinIndex = (page, table_index) =>
    (maxTablesOnPage * (page - 1) + table_index) * maxOrderTableRows;

  const getTableData = (page, table_index) => {
    var minIndex = getMinIndex(page, table_index);
    var nextMinIndex = getMinIndex(page, table_index + 1);
    if (minIndex < orderData.length) {
      return orderData.slice(
        minIndex,
        Math.min(nextMinIndex, orderData.length)
      );
    }
    return [];
  };

  useEffect(() => {
    setPage(1);

    //TODO React18のバッチアップデートを除く
    setTimeout(() => {
      try {
        //ページ１をクリック
        let listPagingButton =
          document.getElementById("paging").children[0].children;
        listPagingButton[1].children[0].click();

        //一番上対象にフォカス
        let topItem = `${priceDetailTypeId}-orderInput0`;
        document.getElementById(topItem).focus();
      } catch {}
    }, 500);
  }, [priceDetailTypeId]);

  return (
    <Box>
      <Grid container spacing={2} marginBottom={2}>
        {[...Array(maxTablesOnPage)].map((_, i) => (
          <Grid
            item
            xs
            key={"table_" + (maxTablesOnPage * (page - 1) + i).toString()}
          >
            <OrderEditTable
              data={getTableData(page, i)}
              minIndex={getMinIndex(page, i)}
              updateInputOrderUnits={updateInputOrderUnits}
              shortcut={props.shortcut}
              priceTableSetting={priceTableSetting}
            />
          </Grid>
        ))}
      </Grid>
      <Grid container>
        <Grid item xs={12} textAlign="center">
          <Pagination
            count={Math.ceil(
              orderData.length / (maxOrderTableRows * maxTablesOnPage)
            )}
            value={page}
            variant="outlined"
            shape="rounded"
            onChange={handleChangeTablePage}
            defaultPage={1}
            sx={{ display: "inline-block" }}
            id="paging"
          />
        </Grid>
      </Grid>
    </Box>
  );
}

// 注文票(編集)ページ
export default function OrderEditPage() {
  let location = useLocation();
  const navigate = useNavigate();

  const [tableTabPosition, setTableTabPosition] = useState(1);
  const [orderData, setOrderData] = useState([]);
  const [orderDataInitial, setOrderDataInitial] = useState([]);
  const [searchCondition, setSearchCondition] = useState({
    productName: "",
    origin: "",
    priceFrom: null,
    priceTo: null,
    includeShortage: true,
    hasOrder: false,
  });
  const [filteredOrderData, setFilteredOrderData] = useState([]);

  useEffect(() => {
    FilterOrderData();
  }, [orderData, searchCondition, tableTabPosition]);

  async function FilterOrderData() {
    // console.log(orderData);

    let afterFilter = orderData.filter(
      (x) => x.priceDetailTypeId == tableTabPosition
    );

    if (searchCondition.hasOrder == true) {
      afterFilter = afterFilter.filter((x) => x.orderQuantity > 0);
    }

    if (searchCondition.productName != "") {
      afterFilter = afterFilter.filter((x) =>
        x.productName.includes(searchCondition.productName)
      );
    }
    if (searchCondition.origin !== "") {
      afterFilter = afterFilter.filter((x) =>
        x.origin.includes(searchCondition.origin)
      );
    }
    if (
      searchCondition.priceFrom != null &&
      !Number.isNaN(searchCondition.priceFrom)
    ) {
      afterFilter = afterFilter.filter(
        (x) => x.marketPrice >= searchCondition.priceFrom
      );
    }
    if (
      searchCondition.priceTo != null &&
      !Number.isNaN(searchCondition.priceTo)
    ) {
      afterFilter = afterFilter.filter(
        (x) => x.marketPrice <= searchCondition.priceTo
      );
    }
    if (searchCondition.includeShortage === false) {
      afterFilter = afterFilter.filter(
        (x) => x.isShortage === false || x.isShortage === null
      );
    }

    //順をソートする
    afterFilter = afterFilter.sort(compareDataByDisplayOrder);

    setFilteredOrderData(afterFilter);
  }

  // 表示順を使って２つのデータを比較
  const compareDataByDisplayOrder = (data_a, data_b) => {
    return data_a.priceDetailTypeId - data_b.priceDetailTypeId;
  };

  const [shop, setShop] = useState({});
  const [shippingDate, setShippingDate] = useState("");
  const [marketPriceId, setMarketPriceId] = useState(null);
  const [marketPriceTableInfo, setMarketPriceTableInfo] = useState(null);

  // 注文データ更新中をあらわすstate
  const [isUpdating, setUpdating] = useState(false);
  // 画面ステータスをcontextから呼出
  const { isChanged, setChanged } = useContext(ScreenStatusContext);

  let userInfo = decrypt(sessionStorage.userInfo);
  let userTypeCd = userInfo.userTypeCd;
  let shopId = userInfo.shopId;

  // 市況価格表　履歴日
  const marketPriceHistoryDate = location.state
    ? location.state.marketPriceHistoryDate
    : null;

  if (!shopId) {
    shopId = location.state.shopId;
  }

  useEffect(() => {
    GetShopInfo(shopId);
  }, [shopId]);

  async function GetShopInfo() {
    var response = await searchShopInfoList({ shopId });
    setShop(response.listShopInfo[0]);
  }

  // 市況価格表データ取得後の初期タブ位置を取得する
  const getInitialTableTabPosition = (priceInfoList) => {
    if (
      priceInfoList.length === 0 ||
      priceInfoList.some((productData) => productData.priceDetailTypeId === 1)
    ) {
      return 1;
    }
    if (
      priceInfoList.some((productData) => productData.priceDetailTypeId === 2)
    ) {
      return 2;
    }
    return 3;
  };

  useEffect(() => {
    getMarketPriceId(shop);
  }, [shop]);
  // 市況価格表IDを取得する。存在しなければ市況価格表を作成してIDを返す
  const getMarketPriceId = async (shop) => {
    if (!shop.customerId || !shop.shopId) return;
    try {
      let marketPriceId = location.state.marketPriceId;
      if (!marketPriceId) {
        let marketPriceIdRes = await postMarketPriceSearchIdAPI({
          customerId: shop.customerId,
          shopId: shop.shopId,
        });

        marketPriceId = marketPriceIdRes.marketPriceId;
      }

      setMarketPriceId(marketPriceId);
    } catch (err) {
      alert(MSG_ERR_UNEXPECTED);
    }
  };

  useEffect(() => {
    (async () => {
      if (marketPriceId && shop.shopId) {
        let marketPriceTableRes = await postMarketPriceSearchTableInfoListAPI({
          marketPriceId,
          marketPriceHistoryDate,
        });
        let marketPriceTableInfo =
          marketPriceTableRes.marketPriceTableInfoList[0];
        setMarketPriceTableInfo(marketPriceTableInfo);

        initializeShippingDate(
          marketPriceTableInfo.shippingDateFrom,
          marketPriceTableInfo.shippingDateTo,
          marketPriceHistoryDate
        );

        GetOrderData(marketPriceId, shop.shopId, marketPriceHistoryDate);
      }
    })();
  }, [marketPriceId]);

  const shortcut = useShortcut({
    tab: 1,
    item: "orderInput",
    index: -1,
  });

  async function GetOrderData(marketPriceId, shopId, marketPriceHistoryDate) {
    try {
      var response = await getListOrderDetail({
        marketPriceId: marketPriceId,
        customerId: shop.customerId,
        shopId: shop.shopId,
        marketPriceHistoryDate: marketPriceHistoryDate,
        orderDateFrom: marketPriceHistoryDate,
        orderDateTo: marketPriceHistoryDate,
      });
      let listOrderData = response.listOrderDetailInfo.map((x) => ({
        ...x,
        shopId: x.shopOrderInfo[0].shopId,
        orderDetailId: x.shopOrderInfo[0].orderDetailId,
        orderQuantity: x.shopOrderInfo[0].orderQuantity,
        displayOrigin: getDisplayOriginWithOther(x.origin, x.isOriginOther),
        primePriceMarkUpRate: x.isUsingSellingPrice
          ? new Decimal(x.primePriceMarkUpRate)
          : null,
        primePriceMarkUpRatePercentage: x.isUsingSellingPrice
          ? decimalToPercentDecimal(
              new Decimal(x.primePriceMarkUpRate)
            ).toFixed(2) + "%"
          : null,
        primePrice: x.isUsingSellingPrice
          ? getPrimePrice(x.marketPrice, x.primePriceMarkUpRate)
          : null,
        sellingPriceMarkUpRate: x.isUsingSellingPrice
          ? new Decimal(x.sellingPriceMarkUpRate)
          : null,
        sellingPriceMarkUpRatePercentage: x.isUsingSellingPrice
          ? decimalToPercentDecimal(
              new Decimal(x.sellingPriceMarkUpRate)
            ).toFixed(2) + "%"
          : null,
        sellingPrice: x.isUsingSellingPrice
          ? getSellingPrice(
              x.marketPrice,
              x.primePriceMarkUpRate,
              x.sellingPriceMarkUpRate
            )
          : null,
      }));
      setOrderData(listOrderData);

      const orderDataInitial = listOrderData.reduce(
        (map, { productId, productDetailId, priceDetailTypeId, ...rest }) => {
          const key = `${productId}-${productDetailId}-${priceDetailTypeId}`;
          map[key] = rest;
          return map;
        },
        {}
      );
      setOrderDataInitial(orderDataInitial);

      setTableTabPosition(getInitialTableTabPosition(listOrderData));
      // FilterOrderData(listOrderData);
    } catch {
      alert("SetOrderDataエラーが発生しました。");
      setOrderData([]);
    }
  }

  // 出荷日を初期化する
  const initializeShippingDate = async (
    initDateFrom,
    initDateTo,
    marketPriceHistoryDate
  ) => {
    let shippingDate = "";
    let todayDateStr = getHyphenedDate(new Date());

    if (marketPriceHistoryDate) {
      shippingDate = marketPriceHistoryDate;
    } else if (initDateFrom && !initDateTo && initDateFrom > todayDateStr) {
      shippingDate = initDateFrom;
    } else if (!initDateFrom && initDateTo > todayDateStr) {
      shippingDate = initDateTo;
    } else {
        shippingDate = getHyphenedDate(new Date());
    }

    setShippingDate(shippingDate);
  };

  const handleChangeTab = (event, tabPos) => {
    console.log("handle change tab", tabPos);
    setTableTabPosition(tabPos);
  };

  async function handleClickOrder() {
    setUpdating(true);

    try {
      SendOrderToServer();
      setChanged(false);
      alert("注文完了しました。");
    } catch {
      alert("注文できませんでした。");
    } finally {
      setUpdating(false);
    }
  }

  async function SendOrderToServer() {
    if (getOrderIsLimited(userInfo, marketPriceTableInfo)) {
      throw new Error("注文締め切り時刻を過ぎました。");
    }
    var insertOrderData = orderData
      .filter((x) => x.isDataChanged == true)
      .map((o) => ({
        productId: o.productId,
        productDetailId: o.productDetailId,
        priceDetailTypeId: o.priceDetailTypeId,
        orderUnit: 1, //TODO 発注単位
        unitQuantity: 1, //TODO 発注単位
        orderDetailId: o.orderDetailId,
        orderQuantity: o.orderQuantity,
        orderPrice: o.marketPrice,
        displayOrder: o.displayOrder,
        isSimpleOrder: o.isAdditionalOrder || false,
        createdId: 1,
        updatedId: 1,
      }));
    await insertOrder({
      // customerId: shop.customerId, //TODO Backendで判定する
      shopId: shop.shopId, //TODO Backendで判定する
      marketPriceId: marketPriceId,
      orderDate: marketPriceHistoryDate || getHyphenedDate(),
      listOrderDetail: insertOrderData,
      createdId: 1,
      updatedId: 1,
    });

    //追加注文は市況価格表を登録
    let marketPriceInsertList = orderData
      .filter((x) => x.isAdditionalOrder == true)
      .map((o) => ({
        marketPriceId: marketPriceId,
        productId: o.productId,
        productDetailId: o.productDetailId,
        displayOrder: o.displayOrder,
        createdId: 1,
        updatedId: 1,
        priceDetailTypeId: o.priceDetailTypeId,
        isOriginOther: o.isOriginOther,
        marketPrice: o.marketPrice,
        isCustomerOrder: o.isCustomerOrder,
        isShortage: o.isShortage,
        remarks: o.remarks,
        isDelete: o.isDelete,
      }));

    // await postMarketPriceUpdateInfoAPI({
    //   marketPriceUpdateInfoList: marketPriceInsertList,
    //   marketPriceHistoryDate: marketPriceHistoryDate,
    // });
    console.log(marketPriceInsertList);
    ResetOrderData();
  }

  function ResetOrderData() {
    let afterResetOrderData = orderData.map((x) => ({
      ...x,
      isDataChanged: false,
      isAdditionalOrder: false,
    }));
    const orderDataInitial = afterResetOrderData.reduce(
      (map, { productId, productDetailId, priceDetailTypeId, ...rest }) => {
        const key = `${productId}-${productDetailId}-${priceDetailTypeId}`;
        map[key] = rest;
        return map;
      },
      {}
    );
    setOrderData(afterResetOrderData);
    setOrderDataInitial(orderDataInitial);
  }

  function updateOrder(item, newOrder) {
    let valueChanged = false;

    let newState = orderData.map((x) => {
      if (
        x.productId === item.productId &&
        x.productDetailId === item.productDetailId &&
        x.priceDetailTypeId === item.priceDetailTypeId
      ) {
        let oldOrder =
          orderDataInitial[
            `${x.productId}-${x.productDetailId}-${x.priceDetailTypeId}`
          ].orderQuantity;
        valueChanged = x.orderQuantity !== oldOrder;
        newOrder.isDataChanged = valueChanged;
        return newOrder;
      } else return x;
    });
    setOrderData(newState);
    setChanged(isChanged || valueChanged);
  }

  const [dialogMode, setDialogMode] = useState(0);

  const [selectedProductData, setSelectedProductData] = useState({
    marketPriceDetailId: 0,
    productName: "",
    origin: "",
    rank: "",
    productClass: "",
    weight: "",
    weightUnit: "",
    orderingUnit: "",
    basePrice: 0,
    marketPrice: 0,
    infoListIndex: 0,
    displayOrder: 1,
  });

  // 商品追加ダイアログを開く
  const openAddProductDialog = (productData) => {
    setSelectedProductData(productData);
    setDialogMode(1);
  };

  // 商品追加ボタン押下時処理
  const onClickAddProduct = (productData) => (event) => {
    openAddProductDialog({
      productId: productData ? productData.productId : 0,
      productName: productData ? productData.productName : "",
      marketPrice: 0,
      displayOrder: 1,
    });
  };

  // 商品追加ダイアログを閉じる処理
  const onCloseDialog = (event) => {
    setDialogMode(0);
  };

  // 「戻る」ボタン押下
  const onClickReturn = (event) => {
    if (confirmWhenChanged(isChanged)) {
      navigate(SYSTEM_PATH_COMPANY + "/order_form_confirm", {
        state: {
          marketPriceId: marketPriceTableInfo.marketPriceId,
          marketPriceHistoryDate: marketPriceHistoryDate,
        },
      });
    }
  };

  // 商品を追加する処理
  const addProduct = (productData, part, price) => {
    const {
      productId,
      productDetailId,
      productName,
      origin,
      displaySize,
      unit,
      orderUnit,
      unitQuantity,
    } = productData;

    const maxDisplayOrder = orderData
      .filter((x) => x.priceDetailTypeId === part)
      .reduce((max, obj) => {
        return obj.displayOrder > max ? obj.displayOrder : max;
      }, 0);
    const displayOrder = maxDisplayOrder + 1;

    const newMarketPriceInfo = {
      ...productData,
      marketPriceId: marketPriceId,
      priceDetailTypeId: part,
      marketPrice: price,
      rank: displaySize,
      isShortage: false,
      isOriginOther: false,
      marketPriceInput: price.toLocaleString(),
      validation: true,
      isDelete: false,
      isDataChanged: true,
      isCustomerOrder: true,
      remarks: "",
      orderQuantity: 0,
      orderDetailId: null,
      // infoListIndex: insertIndex >= 0 ? insertIndex : orderData.length,
      isAdditionalOrder: true,
      displayOrder,
    };

    var newInfoList = [...orderData, newMarketPriceInfo];
    setOrderData(newInfoList);
    setChanged(true);
  };

  // 商品マスタ追加ダイアログを開く
  const openAddProductMasterDialog = (productData) => {
    setSelectedProductData(productData);
    setDialogMode(3);
  };

  // 商品明細マスタ追加ダイアログ
  const openAddProductDetailMasterDialog = (productData) => {
    setSelectedProductData(productData);
    setDialogMode(4);
  };

  const handleKeyDown = useCallback(
    (e) => {
      if (e.key === "ArrowUp") {
        e.preventDefault();
        if (tableTabPosition > 1) {
          setTableTabPosition((prevPosition) => prevPosition - 1);
        }
      } else if (e.key === "ArrowDown") {
        e.preventDefault();
        if (tableTabPosition < 3) {
          setTableTabPosition((prevPosition) => prevPosition + 1);
        }
      }
    },
    [tableTabPosition]
  );

  useEffect(() => {
    document.addEventListener("keydown", handleKeyDown);
    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [handleKeyDown]);

  // 出力する出荷日の文字列を取得する
  const getShippingDateOutput = (shippingDate) => {
    return "出荷日 : " + getYearMonthDateDisplay(new Date(shippingDate));
  };

  // 価格表出力設定を取得する
  const getPriceTableSetting = (userInfo, marketPriceTableInfo) => {
    if (marketPriceTableInfo) {
      return {
        unitPriceCd: marketPriceTableInfo.unitPriceCd,
        orderIsLimited: getOrderIsLimited(userInfo, marketPriceTableInfo),
        isUsingSellingPrice: marketPriceTableInfo.isUsingSellingPrice,
      };
    }

    return {};
  };

  // 注文が締め切り後かどうかを取得
  const getOrderIsLimited = (userInfo, marketPriceTableInfo) => {
    let nowDate = new Date();

    if (
      userInfo.userTypeCd === 1 ||
      !marketPriceTableInfo ||
      !marketPriceTableInfo.orderDeadlineHour
    ) {
      return false;
    }
    console.log(
      nowDate.getHours(),
      nowDate.getHours() > marketPriceTableInfo.orderDeadlineHour
    );

    return nowDate.getHours() >= marketPriceTableInfo.orderDeadlineHour;
  };

  // 注文締め時間テキストを取得する
  const getOrderDeadlineText = (userInfo, marketPriceTableInfo) => {
    if (
      userInfo.userTypeCd === 1 ||
      !marketPriceTableInfo ||
      !marketPriceTableInfo.orderDeadlineHour
    ) {
      return "";
    }

    let amPmHour = getAmPmHour(marketPriceTableInfo.orderDeadlineHour);
    return `※発注は、${
      amPmHour.amPm
    }${amPmHour.hour.toString()}時までにお願い致します。`;
  };

  return (
    <CustomerTitledPage title="注文票　注文内容編集">
      <Typography fontWeight="bold" fontSize={30}>
        {/* テストスーパー　伊那店　様向け　注文票 */}
        {`${shop.customerName}  ${shop.shopName} 様向け　注文票`}
      </Typography>

      <Typography sx={{ fontSize: 20, textAlign: "right" }}>
        {getShippingDateOutput(shippingDate)}
      </Typography>

      <OrderDataSearchForm
        searchCondition={searchCondition}
        setSearchCondition={setSearchCondition}
      />

      <Box marginTop={2} marginBottom={2}>
        <Grid container alignItems="baseline" spacing={1}>
          <Grid item xs>
            <Tabs value={tableTabPosition} onChange={handleChangeTab}>
              <Tab label="蔬菜" value={1} sx={infoTableCellSx} />
              <Tab label="果物" value={2} sx={infoTableCellSx} />
              <Tab label="スポット" value={3} sx={infoTableCellSx} />
            </Tabs>
          </Grid>
          <Grid item xs="auto">
            <Typography
              sx={{
                ...infoTableCellSx,
                paddingInline: 5,
              }}
            >
              {getOrderDeadlineText(userInfo, marketPriceTableInfo)}
            </Typography>
          </Grid>

          <Grid
            item
            xs="auto"
            textAlign="right"
            display={userTypeCd == 1 ? "inherid" : "none"}
          >
            <Button
              variant="outlined"
              color="warning"
              onClick={onClickAddProduct(null)}
              sx={{ ...infoTableCellSx }}
            >
              商品追加
            </Button>
          </Grid>
          <Grid item xs="auto" textAlign="right">
            <Button
              variant="contained"
              onClick={handleClickOrder}
              sx={{ ...infoTableCellSx }}
              disabled={
                getOrderIsLimited(userInfo, marketPriceTableInfo) || isUpdating
              }
              mx={1}
            >
              注文確定
            </Button>
          </Grid>
          <Grid
            item
            xs="auto"
            textAlign="right"
            display={userTypeCd == 1 ? "inherid" : "none"}
          >
            <Button
              variant="outlined"
              color="primary"
              onClick={onClickReturn}
              sx={{ ...infoTableCellSx }}
              mx={1}
            >
              戻る
            </Button>
          </Grid>
        </Grid>
      </Box>

      <Box>
        <OrderTableTabContent
          orderData={filteredOrderData}
          updateOrder={updateOrder}
          priceDetailTypeId={tableTabPosition}
          shortcut={shortcut}
          priceTableSetting={getPriceTableSetting(
            userInfo,
            marketPriceTableInfo
          )}
        />
      </Box>

      <AddProductDialog
        open={dialogMode === 1}
        tabPosition={tableTabPosition}
        productData={selectedProductData}
        onClose={onCloseDialog}
        addProduct={addProduct}
        priceTitle="市況価格"
        openAddProductMasterDialog={openAddProductMasterDialog}
        openAddProductDetailMasterDialog={openAddProductDetailMasterDialog}
        addedProductList={orderData.filter((data) => !data.isDelete)}
        hideDisplayOrder={true}
      />

      <AddProductMasterDialog
        open={dialogMode === 3}
        onClose={onCloseDialog}
        productData={selectedProductData}
        openAddProductDialog={openAddProductDialog}
        openAddProductDetailMasterDialog={openAddProductDetailMasterDialog}
      />

      <AddProductDetailMasterDialog
        open={dialogMode === 4}
        onClose={onCloseDialog}
        productData={selectedProductData}
        openAddProductDialog={openAddProductDialog}
      />
    </CustomerTitledPage>
  );
}
